var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarketCart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 720,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 640,
    y1: 0,
    x2: 640,
    y2: 720,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect",
    id: "fill0"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#F6F8FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ABC0E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#ABC0E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7D5ED"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1280,
    height: 720,
    fill: "url(#fill0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M978.5 155.5 899 473.5 419 473.5 339.5 155.5Z",
    stroke: "#172C51",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "#4472C4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.5 547.5C438.5 513.811 465.139 486.5 498 486.5 530.861 486.5 557.5 513.811 557.5 547.5 557.5 581.189 530.861 608.5 498 608.5 465.139 608.5 438.5 581.189 438.5 547.5Z",
    stroke: "#172C51",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "#4472C4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.5 547.5C771.5 513.811 798.139 486.5 831 486.5 863.861 486.5 890.5 513.811 890.5 547.5 890.5 581.189 863.861 608.5 831 608.5 798.139 608.5 771.5 581.189 771.5 547.5Z",
    stroke: "#172C51",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "#4472C4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.068 156.857 381.594 361.491 344.2 339.329 308.145 193.303 159.673 229.962 123.005 208.229Z",
    stroke: "#172C51",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "#4472C4",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketCart);
export default __webpack_public_path__ + "static/media/marketCart.7d0226a8d8ff18d5fadb2664fdd272d8.svg";
export { ForwardRef as ReactComponent };